module.exports = __webpack_public_path__ + "img/RITA.dfb9b1cd.jpeg";